/**
 * PRIMEX PRICING CONFIGURATOR — assets/primex-configurator.js  (v14.8, round products fall back to the native Price field when mc_cents/mc_euros are empty)
 * v13: + FIX upload click bug (v12 label contained a <button>, which became the label's
 *        implicit target and swallowed clicks) -> new Drag & Drop zone per client design
 *      + NEW Mit Druck / Ohne Druck toggle (client point 2): Ohne Druck hides upload,
 *        catalogue and print data (fabric still priced; unprinted MC pending Wolfgang Q3)
 *      + NEW dual fabric front/back for freestanding products (formula flag "dualFabric")
 *      + catalogue motif selected -> print data hidden AND excluded from price (point 6)
 *      + dimming moved after Textildruck (markup change in liquid, point 7)
 *      + "ralIncluded":true formula flag: RAL selectable at no charge (architect products)
 *      + v13.4: "colorsDisabled":true formula flag (SILMEA/LUMMEA/INTEGRA: predefined
 *        colours, no colour option, no colour cart property); red lines removed;
 *        Dimmung back under the colour selection with bold label
 *      + v13.3: frame colours with use_formula=true (black/white coating) are priced
 *        by the perimeter formula (Umfang x ralRate + ralFlat) like RAL, instead of a
 *        flat surcharge; standard silver stays free; ralIncluded products charge 0
 *      + v13.2: the cable diagram is DRAWN AS AN INLINE SVG (frame, numbered circles,
 *        plug icon) — responsive on every device, numbers are real elements: hover
 *        shows a red ring, click selects and syncs the dropdown. Uses hotspot
 *        percentages from CFG.cableHotspots; without them the metaobject image +
 *        zoom popup is shown as before.
 *      + kept from v12: tooltips (option_tooltips), taxesIncluded net/gross switch,
 *        FormData submit takeover for files, drawer ALWAYS opens after add to cart
 *      + v14.7: mc_cents can ALSO be entered directly in EUROS via a new optional
 *        variant metafield custom.mc_euros — for new round products, no x100 math
 *        needed. If present it wins; existing integer-cents products are untouched.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('px-config');
  var root = document.getElementById('px-configurator');
  if (!cfgEl || !root) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('PX: bad config JSON', e); return; }

  // ---------------- i18n ----------------
  var DICT = {
    de: {
      dims: 'Breite × Höhe in cm',
      dims3: 'Breite × Höhe × Tiefe in cm',
      depth: 'Tiefe',
      uploadLabel: 'Eigene Bilddatei hochladen',
      uploadMax: '(max. 20 MB)',
      dropText: 'Drag & Drop Ihrer Dateien oder',
      browse: 'Datei auswählen',
      uploadHint: 'Erlaubt: JPG, PNG, PDF, AI, EPS.',
      sideFront: '(Vorderseite)',
      sideBack: '(Rückseite)',
      addonTitle: 'Dazu passend:',
      adNet: 'netto',
      adGross: 'inkl. 19% MwSt.',
      pAddonFor: 'Zubehör für',
      frameColor: 'Rahmenfarbe:',
      ralOption: 'Individuelle RAL-Farbe',
      ralPlaceholder: 'RAL-Farbton, z. B. RAL 3020',
      execution: 'Ausführung',
      withT: 'Mit Stoffbanner',
      withoutT: 'Ohne Stoffbanner',
      printWith: 'Mit Druck',
      printWithout: 'Ohne Druck',
      dimming: 'Mit Dimmung',
      cableLabel: 'Auswahl über Bild',
      infoModalTitle: 'Information',
      textilePrinting: 'Stoffbanner',
      textileType: 'Auswahl Textilart',
      textileTypeFront: 'Auswahl Textilart Vorderseite',
      textileTypeBack: 'Auswahl Textilart Rückseite',
      catalogToggle: 'Katalogmotiv wählen',
      printData: 'Druckdatenverarbeitung',
      netUnit: 'netto / Stück',
      vatNote: function (r) { return 'inkl. ' + Math.round(r * 100) + '% MwSt. / Stück'; },
      quoteNote: function (n) { return 'Ab einer Menge von mehr als ' + n + ' Stück erstellen wir Ihnen gerne ein individuelles Angebot. Bitte kontaktieren Sie uns.'; },
      errRange: function (f, min, max) { return f + ' muss zwischen ' + min + ' und ' + max + ' cm liegen.'; },
      width: 'Breite', height: 'Höhe', enter: 'Bitte Maße eingeben.',
      lineTotal: function (q, s) { return q + ' × = ' + s + ' brutto'; },
      pW: 'Breite (cm)', pH: 'Höhe (cm)', pT: 'Tiefe (cm)', pDim: 'Dimmung', pFab: 'Textil',
      pDia: 'Durchmesser (cm)',
      pFabF: 'Textil Vorderseite', pFabB: 'Textil Rückseite', pPrint: 'Druck',
      pCol: 'Rahmenfarbe', pRal: 'RAL-Farbe', pExec: 'Ausführung', pPd: 'Druckdatenverarbeitung',
      pCab: 'Kabelausgang', pDsg: 'Bildmotiv',
      yes: 'Ja', pos: function (n) { return 'Position ' + n; },
      priceOnRequest: 'Preis auf Anfrage – bitte kontaktieren Sie uns.',
      addError: 'Fehler beim Hinzufügen zum Warenkorb.',
      fmtLocale: 'de-DE'
    },
    en: {
      dims: 'Individual dimensions in cm (W x H)',
      dims3: 'Individual dimensions in cm (W x H x D)',
      depth: 'Depth',
      uploadLabel: 'Upload your own image file',
      uploadMax: '(max. 20 MB)',
      dropText: 'Drag & drop your files or',
      browse: 'Select file',
      uploadHint: 'Allowed: JPG, PNG, PDF, AI, EPS.',
      sideFront: '(front side)',
      sideBack: '(back side)',
      addonTitle: 'Matching add-ons:',
      adNet: 'net',
      adGross: 'incl. 19% VAT',
      pAddonFor: 'Accessory for',
      frameColor: 'Frame color:',
      ralOption: 'Individual RAL COLOUR',
      ralPlaceholder: 'RAL code, e.g. RAL 3020',
      execution: 'Execution',
      withT: 'With Textile',
      withoutT: 'Without textile (frame only)',
      printWith: 'With printing',
      printWithout: 'Without printing',
      dimming: 'With dimming',
      cableLabel: 'Select from image',
      infoModalTitle: 'Information',
      textilePrinting: 'Textile printing',
      textileType: 'Selection Textile type',
      textileTypeFront: 'Textile type front',
      textileTypeBack: 'Textile type back',
      catalogToggle: 'Select a specified subject from our image catalogue',
      printData: 'Print data processing',
      netUnit: 'net / unit',
      vatNote: function (r) { return 'incl. ' + Math.round(r * 100) + '% VAT / unit'; },
      quoteNote: function (n) { return 'For quantities above ' + n + ' we prepare an individual quotation. Please contact us.'; },
      errRange: function (f, min, max) { return f + ' must be between ' + min + ' and ' + max + ' cm.'; },
      width: 'Width', height: 'Height', enter: 'Please enter dimensions.',
      lineTotal: function (q, s) { return q + ' × = ' + s + ' gross'; },
      pW: 'Width (cm)', pH: 'Height (cm)', pT: 'Depth (cm)', pDim: 'Dimming', pFab: 'Fabric',
      pDia: 'Diameter (cm)',
      pFabF: 'Fabric front', pFabB: 'Fabric back', pPrint: 'Printing',
      pCol: 'Frame colour', pRal: 'RAL colour', pExec: 'Execution', pPd: 'Print data processing',
      pCab: 'Cable output', pDsg: 'Image catalogue subject',
      yes: 'Yes', pos: function (n) { return 'Position ' + n; },
      priceOnRequest: 'Price on request – please contact us.',
      addError: 'Error adding to cart.',
      fmtLocale: 'en-GB'
    }
  };

  // v14.22: language is decided ONCE, purely from Shopify's own URL-based
  // locale (CFG.locale, fed by request.locale in the liquid file) — no
  // manual toggle, no localStorage override. Switching language means the
  // customer is on a different URL (/en/... vs default), same as any other
  // translated part of the storefront.
  var lang = (CFG.locale === 'en') ? 'en' : 'de';

  var L = DICT[lang];
  var fmt = new Intl.NumberFormat(L.fmtLocale, { style: 'currency', currency: 'EUR' });

  // ---------- fabric tooltips from custom.option_tooltips (normalized match) ----------
  var TIPMAP = {};
  var tipNorm = null;
  (function () {
    var src = CFG.optionTooltips || null;
    if (!src || typeof src !== 'object') return;
    tipNorm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9äöüß]/g, ''); };
    Object.keys(src).forEach(function (k) { TIPMAP[tipNorm(k)] = src[k]; });
  })();
  function tooltipFor(title) {
    if (!tipNorm || !title) return null;
    return TIPMAP[tipNorm(title)] || null;
  }

  // All cart property names in BOTH languages (to clear stale ones on switch)
  var ALL_PROP_KEYS = [];
  ['de', 'en'].forEach(function (lg) {
    ['pW', 'pH', 'pT', 'pDia', 'pDim', 'pExec', 'pFab', 'pFabF', 'pFabB', 'pPrint', 'pPd', 'pCab', 'pDsg', 'pCol', 'pRal'].forEach(function (k) {
      if (ALL_PROP_KEYS.indexOf(DICT[lg][k]) === -1) ALL_PROP_KEYS.push(DICT[lg][k]);
    });
    [' 1', ' 2'].forEach(function (sfx) {
      var key = DICT[lg].pFab + sfx;
      if (ALL_PROP_KEYS.indexOf(key) === -1) ALL_PROP_KEYS.push(key);
    });
  });

  // ---------- elements ----------
  var $w = document.getElementById('px-width');
  var $h = document.getElementById('px-height');
  var $t = document.getElementById('px-depth'); // only exists for BHT products
  var $err = document.getElementById('px-dim-error');
  function setErr(msg) { if ($err) $err.textContent = msg; }
  var $dimWrap = document.getElementById('px-dimming-wrap');
  var $dim = document.getElementById('px-dimming');
  var $ralWrap = document.getElementById('px-ral-code-wrap');
  var $ralCode = document.getElementById('px-ral-code');
  var $colorName = document.getElementById('px-color-name');
  var $execBtns = root.querySelectorAll('.px-exec-btn');
  var $printBtns = root.querySelectorAll('.px-print-btn');
  var $printRow = document.getElementById('px-print');
  var $textileSection = document.getElementById('px-textile-section');
  var $fabricSelect = document.getElementById('px-fabric-select');
  var $fabricSelect2 = document.getElementById('px-fabric-select2'); // dualFabric products only
  var $fabricInfo = document.getElementById('px-fabric-info');
  var $pdWrap = document.getElementById('px-pd-wrap');
  var $pfUpWraps = Array.prototype.slice.call(root.querySelectorAll('.px-upload-wrap'));
  var $pdSelect = document.getElementById('px-pd-select');
  var $designWrap = document.getElementById('px-design-wrap');
  var $designToggle = document.getElementById('px-design-toggle');
  var $designArea = document.getElementById('px-design-area');
  var $designCatalog = document.getElementById('px-design-catalog');
  var $cableSelect = document.getElementById('px-cable-select');
  var $cableDiagram = document.getElementById('px-cable-diagram');
  var $price = document.getElementById('px-price');
  var $net = document.getElementById('px-price-net');
  var $gross = document.getElementById('px-price-gross');
  var $line = document.getElementById('px-line-total');
  var $vatNote = document.getElementById('px-vat-note');
  var $quote = document.getElementById('px-quote-note');
  var $lightbox = document.getElementById('px-lightbox');
  var $lightboxImg = document.getElementById('px-lightbox-img');
  var $lightboxClose = document.getElementById('px-lightbox-close');
  var $lightboxHotspots = document.getElementById('px-lightbox-hotspots');
  // v14.4: shared fabric-info popup (one modal, filled per icon clicked)
  var $infoModal = document.getElementById('px-info-modal');
  var $infoModalBody = document.getElementById('px-info-modal-body');
  var $infoModalClose = document.getElementById('px-info-modal-close');
  var $infoModalTitle = document.getElementById('px-info-modal-title');
  var $cableSvgWrap = document.getElementById('px-cable-svg');
  // v14.0: Handelsware textile add-on
  var $hwWrap = document.getElementById('px-hw-textile');
  var $hwModeBtns = $hwWrap ? $hwWrap.querySelectorAll('#px-hw-modes .px-exec-btn') : [];
  var $hwPd = document.getElementById('px-hw-pd');
  var $hwPdSelect = document.getElementById('px-hw-pd-select');
  var hwCount = 0; // 0 = Ohne Textil
  // v14.2: add-on products ("Dazu passend")
  var $addons = document.getElementById('px-addons');
  function selectedAddonBox() {
    if (!$addons) return null;
    var boxes = $addons.querySelectorAll('.addon-product-checkbox:checked');
    return boxes.length ? boxes[boxes.length - 1] : null;
  }
  function addonSelection() {
    var box = selectedAddonBox();
    if (!box) return null;
    var item = box.closest('.addon-product-item');
    var sel = item ? item.querySelector('.px-addon-variant') : null;
    var vid = box.dataset.variantId;
    var base = parseInt(box.dataset.price, 10) || 0;
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt) { vid = opt.value; base = parseInt(opt.dataset.variantPrice, 10) || base; }
    }
    return { variantId: vid, baseCents: base, title: box.dataset.title || '' };
  }
  // add-ons (feet etc.) are Handelsware-Standard products: base x CF x KRF x QF
  function addonUnitNetCents(qty) {
    var ad = addonSelection();
    if (!ad || !ad.baseCents) return 0;
    var qf = qtyFactor(qty);
    if (qf === null) qf = 0.97; // above threshold the MAIN product already blocks checkout
    var krf = (CFG.factors && CFG.factors.krf) ? CFG.factors.krf : 1.0;
    return Math.round(ad.baseCents * CFG.factors.cf * krf * qf);
  }
  function showAddons(on) {
    if ($addons) $addons.style.display = on ? 'block' : 'none';
  }
  function refreshAddonTiles() {
    if (!$addons) return;
    var qty = getQty();
    var qf = qtyFactor(qty); if (qf === null) qf = 0.97;
    var krf = (CFG.factors && CFG.factors.krf) ? CFG.factors.krf : 1.0;
    $addons.querySelectorAll('.addon-product-item').forEach(function (item) {
      var box = item.querySelector('.addon-product-checkbox');
      var sel = item.querySelector('.px-addon-variant');
      var base = parseInt(box.dataset.price, 10) || 0;
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt) base = parseInt(opt.dataset.variantPrice, 10) || base;
      }
      var net = Math.round(base * CFG.factors.cf * krf * qf);
      var gross = Math.round(net * (1 + CFG.settings.vat));
      var nEl = item.querySelector('.px-ad-net');
      var gEl = item.querySelector('.px-ad-gross');
      if (nEl) nEl.textContent = fmt.format(net / 100);
      if (gEl) gEl.textContent = fmt.format(gross / 100);
    });
  }
  if ($addons) {
    $addons.querySelectorAll('.addon-product-checkbox').forEach(function (box) {
      box.addEventListener('change', function () {
        if (box.checked) { // single-select: uncheck the others
          $addons.querySelectorAll('.addon-product-checkbox').forEach(function (b) {
            if (b !== box) b.checked = false;
          });
        }
        schedule();
      });
    });
    $addons.querySelectorAll('.px-addon-variant').forEach(function (sel) {
      sel.addEventListener('change', function () {
        // interacting with an add-on's variant means the customer wants THIS add-on:
        // select it and enforce single-select strictly
        var item = sel.closest('.addon-product-item');
        var box = item ? item.querySelector('.addon-product-checkbox') : null;
        if (box) {
          box.checked = true;
          $addons.querySelectorAll('.addon-product-checkbox').forEach(function (b) {
            if (b !== box) b.checked = false;
          });
        }
        refreshAddonTiles();
        schedule();
      });
      // clicking the select must not toggle the surrounding label's checkbox
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    refreshAddonTiles();
  }

  // Move lightbox to <body>: theme sections use CSS transforms which trap position:fixed
  if ($lightbox && $lightbox.parentElement !== document.body) {
    document.body.appendChild($lightbox);
  }

  // execution mode: 'NONE' = frame only; 'WITH' = single-fabric products;
  // or a fabricModes code like 'F5'/'T2' for panel-based products
  var execMode = (function () {
    var active = root.querySelector('.px-exec-btn.px-active');
    return active ? active.dataset.mode : 'WITH';
  })();
  // v13: printing mode — 'YES' (default) or 'NO' (Ohne Druck, client point 2)
  var printMode = 'YES';

  function textileOnFn() {
    if (CFG.formula && CFG.formula.kind === 'AREA_FIX') return true; // v14.9: Stoffbanner — always "on", no frame/fabric toggle
    if (CFG.formula && CFG.formula.motifOnly) return true; // v14.11: freestanding acoustic panels — motif upload always available, no fabric-type choice
    if (!$fabricSelect) return false; // acoustic/architect products: no textile at all
    return execMode !== 'NONE';
  }
  function printedFn(fab) {
    return textileOnFn() && printMode === 'YES' && fab && !fab.noPrint;
  }
  function activeFabricMode() {
    var modes = CFG.formula ? CFG.formula.fabricModes : null;
    if (!modes) return null;
    for (var i = 0; i < modes.length; i++) if (modes[i].code === execMode) return modes[i];
    return null;
  }

  if (CFG.formula && CFG.formula.dimmingAvailable && $dimWrap) $dimWrap.style.display = 'flex';

  // ---------- language application ----------
  function hwLocalizeModeButtons() {
    var wrap = document.getElementById('px-hw-modes');
    if (!wrap) return;
    wrap.querySelectorAll('.px-exec-btn').forEach(function (b) {
      var n = parseInt(b.dataset.count, 10) || 0;
      if (n > 0) {
        b.textContent = (lang === 'de')
          ? ('Mit ' + n + ' Textil' + (n > 1 ? 'ien' : ''))
          : ('With ' + n + ' textile' + (n > 1 ? 's' : ''));
      }
    });
  }
  function applyLang() {
    hwLocalizeModeButtons();
    L = DICT[lang];
    fmt = new Intl.NumberFormat(L.fmtLocale, { style: 'currency', currency: 'EUR' });

    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.dataset.i18n;
      if (typeof L[key] === 'string') el.textContent = L[key];
    });
    root.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var key = el.dataset.i18nPlaceholder;
      if (typeof L[key] === 'string') el.placeholder = L[key];
    });

    [$pdSelect, $hwPdSelect].forEach(function (sel) {
      if (!sel) return;
      for (var pi = 0; pi < sel.options.length; pi++) {
        var po = sel.options[pi];
        var pmc = parseFloat(po.dataset.mc || '0') || 0;
        po.text = (po.dataset.name || po.text) + (pmc > 0 ? ' (+ ' + fmt.format(pmc) + ')' : '');
      }
    });

    root.querySelectorAll('.px-dtip').forEach(function (el) {
      var p = parseFloat(el.dataset.price || '0') || 0;
      el.textContent = (el.dataset.name || '') + (p > 0 ? ' (+ ' + fmt.format(p) + ')' : '');
    });

    compute();
  }

  // ---------- product form (Dawn-safe finder) ----------
  function findProductForm() {
    var section = root.closest('.shopify-section') || document;
    var f = section.querySelector('form[data-type="add-to-cart-form"]');
    if (f) return f;
    f = document.querySelector('form[data-type="add-to-cart-form"]');
    if (f) return f;
    f = document.querySelector('product-form form[action*="/cart/add"]');
    if (f) return f;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]') && !(forms[i].id || '').includes('installment')) return forms[i];
    }
    return forms[0] || null;
  }
  var form = findProductForm();
  if (form && root.querySelector('.px-upinput')) {
    form.setAttribute('enctype', 'multipart/form-data');
    // file inputs sit OUTSIDE the form (Custom Liquid block): associate via form attribute
    if (!form.id) form.id = 'px-product-form';
    root.querySelectorAll('.px-upinput').forEach(function (inp) {
      inp.setAttribute('form', form.id);
    });
  }
  var submitBtn = form ? (form.querySelector('[type="submit"]') || form.querySelector('button[name="add"]')) : null;

  function getQty() {
    var q = 1;
    var el = form ? form.querySelector('[name="quantity"]') : null;
    if (!el) el = document.querySelector('[name="quantity"]');
    if (el) q = parseInt(el.value, 10) || 1;
    return q;
  }

  // ---------- pricing core ----------
  function pickTier(b) {
    var tiers = CFG.formula.tiers || [];
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var minOk = (t.minB === undefined) || b >= t.minB;
      var maxOk = (t.maxB === undefined) || b <= t.maxB;
      if (minOk && maxOk) return t;
    }
    return null;
  }

  function qtyFactor(qty) {
    if (qty > CFG.settings.qtyThreshold) return null;
    var list = CFG.qtyFactors || [];
    for (var i = 0; i < list.length; i++) {
      if (qty >= list[i].min && qty <= list[i].max) {
        var f = list[i].factor;
        if (typeof f !== 'number' || f < 0.5 || f > 1.5) {
          console.error('PX: invalid quantity factor', f, 'for qty', qty, '- using 1.0. Fix the metaobject entry!');
          return 1.0;
        }
        return f;
      }
    }
    return 1.0;
  }

  function fabricFromSelect(sel) {
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    if (!opt || !opt.value) return null;
    return {
      articleNo: opt.value,
      mc: parseFloat(opt.dataset.mc),
      title: opt.dataset.title || opt.text,
      noPrint: opt.dataset.noprint === '1'
    };
  }
  function selectedFabric() {
    if (!textileOnFn()) return null;
    // v14.11: motif-only products have no fabric-TYPE select at all — return a
    // synthetic fab so printedFn/selectedPrintData/upload still switch on;
    // computeMCT() below guarantees this never adds any cost.
    // v14.20: EXCEPT when "showFabricSelect":true (Akustikbild family, 9
    // products) — these DO show a real fabric dropdown (e.g. white vs 615007),
    // it is just a production/cosmetic choice with zero price impact, since
    // computeMCT() zeroes the cost purely from the motifOnly flag either way.
    if (CFG.formula && CFG.formula.motifOnly) {
      if (CFG.formula.showFabricSelect) return fabricFromSelect($fabricSelect);
      return { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false };
    }
    return fabricFromSelect($fabricSelect);
  }
  // v13: back-side fabric for dualFabric (freestanding) products
  function selectedFabric2() {
    if (!textileOnFn() || !CFG.formula || !CFG.formula.dualFabric) return null;
    return fabricFromSelect($fabricSelect2) || selectedFabric();
  }

  function selectedColor() {
    var el = root.querySelector('input[name="px-fcolor"]:checked');
    if (!el) return { code: 'SILVER', name: 'Silber', surcharge: 0, isRal: false };
    var isRal = el.dataset.ral === '1';
    return {
      code: el.value,
      name: isRal ? L.ralOption : (el.dataset.name || el.value),
      surcharge: parseFloat(el.dataset.surcharge || '0') || 0,
      useFormula: el.dataset.formula === '1',
      isRal: isRal
    };
  }

  function selectedCable() {
    if (!$cableSelect) return null;
    return { code: $cableSelect.value, name: L.pos($cableSelect.value) };
  }

  function designAllowed(fab) {
    return printedFn(fab) && !!$designWrap;
  }

  function selectedDesign(fab) {
    if (!designAllowed(fab) || !$designToggle || !$designToggle.checked) return null;
    var panel = root.querySelector('.px-design-panel.px-active-panel');
    if (!panel) return null;
    var r = panel.querySelector('input[type="radio"]:checked');
    if (!r) return null;
    return { code: r.value, name: r.dataset.name || r.value, price: parseFloat(r.dataset.price || '0') || 0 };
  }

  // v13 client point 6: when a catalogue motif is chosen, print data is hidden AND not charged
  function selectedPrintData(fab, dsg) {
    if (!printedFn(fab) || dsg || !$pdSelect) return null;
    var opt = $pdSelect.options[$pdSelect.selectedIndex];
    if (!opt) return null;
    return { code: opt.value, name: opt.dataset.name || opt.text, price: parseFloat(opt.dataset.mc || '0') || 0 };
  }

  function validate(b, h, t) {
    var lim = CFG.limits;
    var needT = lim.minT > 0;
    if (!b || !h || (needT && !t)) return L.enter;
    if (b < lim.minB || b > lim.maxB) return L.errRange(L.width, lim.minB, lim.maxB);
    if (h < lim.minH || h > lim.maxH) return L.errRange(L.height, lim.minH, lim.maxH);
    if (needT && (t < lim.minT || t > lim.maxT)) return L.errRange(L.depth, lim.minT, lim.maxT);
    return null;
  }

  // ---- formula-shape helpers ----
  function lengthMeters(rule, b, h, t) {
    switch (rule) {
      case 'L4BHT': return 4 * (b + h + (t || 0)) / 100;
      case 'L2B': return (2 * b) / 100;
      case 'LUSHAPE': return (4 * (h + (t || 0)) + 2 * b) / 100;
      case 'LLSHAPE': return (2 * (b + (t || 0)) + 3 * h) / 100;
      default: return 2 * (b + h) / 100;
    }
  }
  function ralPerimeterMeters(rule, b, h, t) {
    switch (rule) {
      case 'P2B': return (2 * b) / 100;
      case 'PCUBE': return 4 * (b + h + (t || 0)) / 100;
      case 'PUSHAPE': return (4 * (h + (t || 0)) + 2 * b) / 100;
      case 'PLSHAPE': return (2 * (b + (t || 0)) + 3 * h) / 100;
      case 'PCIRCLE': return (Math.PI * b) / 100; // b = diameter in cm here
      case 'P2BH':
      default: return 2 * (b + h) / 100;
    }
  }
  function panelArea(code, b, h, t) {
    switch (code) {
      case 'BT': return (b * (t || 0)) / 10000;
      case 'BH': return (b * h) / 10000;
      case 'TH': return ((t || 0) * h) / 10000;
      default: return 0;
    }
  }
  function computeMCR(b, h, t, dim) {
    var F = CFG.formula;
    var dimVal = (F.tierDim === 'MAX_BT') ? Math.max(b, t || 0) : b;
    if (F.kind === 'QUAD_L') {
      if (!F.quad) return null;
      var Lm = lengthMeters(F.lengthRule || 'L4BHT', b, h, t);
      return F.quad.a * Lm * Lm + F.quad.b * Lm + F.quad.c;
    }
    var tier = pickTier(dimVal);
    if (!tier) return null;
    var coeff = (dim && tier.coeffDim !== undefined) ? tier.coeffDim : tier.coeff;
    var cnst = dim ? tier.constantDim : tier.constant;
    if (F.kind === 'LINEAR_L') {
      var L2 = lengthMeters(F.lengthRule || 'L4BHT', b, h, t);
      return coeff * L2 + (cnst || 0);
    }
    var A = (b * h) / 10000;
    return coeff * A + cnst;
  }
  // v13: dualFabric products price front + back fabric separately
  function computeMCT(fab, fab2, b, h, t) {
    if (!fab) return 0;
    // v14.11: motif-only products (606445/606103/606447) already have BOTH
    // textiles baked into the frame's HKR,T formula ("Rahmen mit 2 Textilien").
    // The upload zones are for the customer's motif image only — never a cost.
    if (CFG.formula && CFG.formula.motifOnly) return 0;
    var A = (b * h) / 10000;
    if (CFG.formula && CFG.formula.dualFabric) {
      var f2 = fab2 || fab;
      return (A * fab.mc + CFG.settings.fabricFlat) + (A * f2.mc + CFG.settings.fabricFlat);
    }
    var mode = activeFabricMode();
    if (mode && mode.panels) {
      var sum = 0;
      for (var i = 0; i < mode.panels.length; i++) {
        var pnl = mode.panels[i];
        sum += (pnl.n || 1) * (panelArea(pnl.area, b, h, t) * fab.mc + CFG.settings.fabricFlat);
      }
      return sum;
    }
    return A * fab.mc + CFG.settings.fabricFlat;
  }

  // v14.34: NEW schema flag "ignoreFabricWidthLimit":true — for products
  // where Katja/Wolfgang confirm every linked fabric should stay selectable
  // no matter how large the product gets (e.g. Deckenhänger "Quader" at max
  // B/H/T). Scoped to THIS product only, via its own Formula JSON — every
  // other product sharing the same fabric metaobject entry keeps its normal
  // max_width_cm restriction untouched. Round products are unaffected: they
  // have no CFG.formula at all, so this check is simply never true there.
  function updateFabricAvailability(b, h, t) {
    var ignoreLimit = !!(CFG.formula && CFG.formula.ignoreFabricWidthLimit);
    [$fabricSelect, $fabricSelect2].forEach(function (sel) {
      if (!sel) return;
      if (ignoreLimit) {
        for (var k = 0; k < sel.options.length; k++) sel.options[k].disabled = false;
        return;
      }
      var need = Math.max(b || 0, h || 0, t || 0);
      var switched = false;
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        var maxw = parseInt(o.dataset.maxw, 10);
        var dis = !!need && !!maxw && need > maxw;
        o.disabled = dis;
        if (dis && o.selected) switched = true;
      }
      if (switched) {
        for (var j = 0; j < sel.options.length; j++) {
          if (!sel.options[j].disabled) { sel.selectedIndex = j; break; }
        }
      }
    });
  }

  function updateTextileUI(fab) {
    var on = textileOnFn();
    if ($textileSection) $textileSection.style.display = on ? 'block' : 'none';
    if ($fabricInfo) {
      var opt = $fabricSelect ? $fabricSelect.options[$fabricSelect.selectedIndex] : null;
      var info = opt ? (tooltipFor(opt.dataset.title || opt.text) || opt.dataset.info) : null;
      if (on && info) { $fabricInfo.textContent = info; $fabricInfo.style.display = 'block'; }
      else { $fabricInfo.style.display = 'none'; }
    }
    var printable = printedFn(fab);
    var designOn = printable && $designToggle && $designToggle.checked;
    // client point 6: catalogue motif chosen -> hide print data
    if ($pdWrap) $pdWrap.style.display = (printable && !designOn) ? 'block' : 'none';
    if ($designWrap) $designWrap.style.display = printable ? 'block' : 'none';
    // upload and catalogue are mutually exclusive; both hidden when Ohne Druck
    $pfUpWraps.forEach(function (w) {
      w.style.display = (printable && !designOn) ? 'block' : 'none';
    });
    if (designOn && anyFiles()) clearAllFiles();
    if (!printable) {
      if ($designToggle && $designToggle.checked) $designToggle.checked = false;
      if (anyFiles()) clearAllFiles();
    }
    if ($designArea) $designArea.style.display = designOn ? 'block' : 'none';
  }

  // v13.9: the scenario can be defined PER VARIANT (variant metafield custom.variant_scenario).
  // Resolution order: the selected variant's own scenario FIRST, then the product-level
  // scenario as the default. Products that only carry the product-level metafield are
  // therefore completely unaffected.
  function selectedVariantId() {
    return form ? (form.querySelector('[name="id"]') || {}).value : null;
  }
  function effectiveScenario() {
    var vid = selectedVariantId();
    var vs = (CFG.variantScenarios && vid) ? CFG.variantScenarios[vid] : null;
    if (vs) return vs;
    return CFG.scenario || null;
  }
  // true if this product is priced by ANY scenario (product-level or on at least one variant)
  function hasScenarioSetup() {
    if (CFG.scenario) return true;
    if (CFG.variantScenarios) {
      for (var k in CFG.variantScenarios) {
        if (CFG.variantScenarios[k]) return true;
      }
    }
    return false;
  }

  // v14.6: parse "100 cm" (or "Ø 100 cm") from the selected variant title —
  // round products (FIXED_MC) have exactly one size dimension, the diameter.
  function fixedMcDiameterCm() {
    var vid = selectedVariantId();
    var title = (CFG.variantTitles && vid) ? CFG.variantTitles[vid] : null;
    if (!title) return null;
    var m = String(title).match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    var d = parseFloat(m[1].replace(',', '.'));
    return d > 0 ? d : null;
  }

  // v14.0: parse "200 x 250 cm" (also "300 x 250cm") from the selected variant title
  function hwVariantDims() {
    var vid = selectedVariantId();
    var title = (CFG.variantTitles && vid) ? CFG.variantTitles[vid] : null;
    if (!title) return null;
    var m = String(title).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    var b = parseFloat(m[1].replace(',', '.'));
    var h = parseFloat(m[2].replace(',', '.'));
    if (!b || !h) return null;
    return { b: b, h: h };
  }
  function hwSlotFabric(i) {
    var sel = $hwWrap ? $hwWrap.querySelector('.px-hw-fabric[data-slot="' + i + '"]') : null;
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return null;
    return { articleNo: opt.value, mc: parseFloat(opt.dataset.mc), title: opt.dataset.title || opt.text };
  }
  function hwSelectedPd() {
    if (!$hwPdSelect || hwCount === 0) return null;
    var opt = $hwPdSelect.options[$hwPdSelect.selectedIndex];
    if (!opt) return null;
    return { code: opt.value, name: opt.dataset.name || opt.text, price: parseFloat(opt.dataset.mc || '0') || 0 };
  }
  // v14.3 — Wolfgang Kapitel 4 (Stand 08/2026):
  //   VKT = MTF (1,7) x SUM over slots of (A_i x HKT_i + 4,45)   — a FIX price:
  //   NO country factor, NO customer-group factor, NO quantity factor.
  //   A_i: the slot's fixed area_m2 if set, otherwise B x H from the variant title.
  //   Applies to HANDELSWARE_STANDARD and HANDELSWARE_FIXED alike.
  function hwSlotArea(i) {
    var slot = $hwWrap ? $hwWrap.querySelector('.px-hw-slot[data-slot="' + i + '"]') : null;
    if (slot && slot.dataset.area) {
      var a = parseFloat(String(slot.dataset.area).replace(',', '.'));
      if (a > 0) return a;
    }
    var dims = hwVariantDims();
    if (!dims) return NaN;
    return (dims.b * dims.h) / 10000;
  }
  function hwTextileUnitCents() {
    if (!$hwWrap || hwCount === 0) return 0;
    var sum = 0;
    for (var i = 1; i <= hwCount; i++) {
      var fab = hwSlotFabric(i);
      var A = hwSlotArea(i);
      if (!fab || isNaN(A)) return NaN;
      sum += A * fab.mc + CFG.settings.fabricFlat;
    }
    var mtf = CFG.settings.mtf || 1.7;
    return Math.round(sum * mtf * 100);
  }
  function writeHwTextileProps(hwPd) {
    for (var s = 1; s <= 6; s++) {
      var key = 'properties[' + L.pFab + ' ' + s + ']';
      if (s <= hwCount) {
        var fb = hwSlotFabric(s);
        setHidden(key, fb ? (fb.title + ' (' + fb.articleNo + ')') : null);
      } else {
        setHidden(key, null);
      }
    }
    setHidden('properties[' + L.pPd + ']', hwPd ? hwPd.name : null);
  }

  // E3/E4: fixed-size (round products) & merchandise — variant base value × factors
  // v13.7: + HANDELSWARE_STANDARD (SP x CF x KRF x QF) + HANDELSWARE_FIXED (no factors at all)
  function computeScenarioPrice() {
    var qty = getQty();
    var vid = selectedVariantId();
    var scen = effectiveScenario();

    // ---- HANDELSWARE_FIXED: identical price for every customer/country/quantity ----
    if (scen === 'HANDELSWARE_FIXED') {
      var fixedCents = (CFG.fixedPriceVariants && vid) ? parseInt(CFG.fixedPriceVariants[vid], 10) : 0;
      if (!fixedCents || fixedCents <= 0) { return fail(L.priceOnRequest); }
      // v14.3: Kapitel 4 textiles are added to Fixpreis products too
      var fxTex = hwTextileUnitCents();
      if (isNaN(fxTex)) { return fail(L.priceOnRequest); }
      var fxPd = hwSelectedPd();
      var fxPdUnitCents = fxPd ? Math.round(fxPd.price * 100 / qty) : 0;
      fixedCents = fixedCents + fxTex + fxPdUnitCents;
      var fGrossCents = Math.round(fixedCents * (1 + CFG.settings.vat));
      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((fixedCents + adN) / 100);
      $gross.textContent = fmt.format((fGrossCents + adG) / 100);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((fGrossCents + adG) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);
      setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? fGrossCents : fixedCents);
      writeHwTextileProps(fxPd);
      setHidden('properties[_cfg]', JSON.stringify({
        a: CFG.articleNo, scenario: scen, vid: vid, hwT: hwCount || null, qty: qty, lang: lang,
        net: fixedCents, gross: fGrossCents, v: CFG.version
      }));
      return;
    }

    // ---- HANDELSWARE_STANDARD: Standardpreis x Country x (NEW) Handelsware discount x Qty ----
    if (scen === 'HANDELSWARE_STANDARD') {
      var spCents = (CFG.standardPriceVariants && vid) ? parseInt(CFG.standardPriceVariants[vid], 10) : 0;
      if (!spCents || spCents <= 0) { return fail(L.priceOnRequest); }
      var hQf = qtyFactor(qty);
      if (hQf === null) {
        $price.style.display = 'none';
        $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
        $quote.style.display = 'block';
        setErr(''); setSubmitEnabled(false); clearProps();
        return;
      }
      var hNet = (spCents / 100) * CFG.factors.cf * CFG.factors.krf * hQf;
      var hNetCents = Math.round(hNet * 100);
      // v14.3: textile FIX price (MTF model) — identical for every customer
      var hwTex = hwTextileUnitCents();
      if (isNaN(hwTex)) { return fail(L.priceOnRequest); }
      var hwPd = hwSelectedPd();
      var hwPdUnitCents = hwPd ? Math.round(hwPd.price * 100 / qty) : 0;
      hNetCents = hNetCents + hwTex + hwPdUnitCents;
      var hGrossCents = Math.round(hNetCents * (1 + CFG.settings.vat));
      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((hNetCents + adN) / 100);
      $gross.textContent = fmt.format((hGrossCents + adG) / 100);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((hGrossCents + adG) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);
      setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? hGrossCents : hNetCents);
      // textile cart properties (production needs to know what was ordered)
      writeHwTextileProps(hwPd);
      setHidden('properties[_cfg]', JSON.stringify({
        a: CFG.articleNo, scenario: scen, vid: vid, hwT: hwCount || null,
        tier: CFG.factors.tier, cty: CFG.factors.country, qty: qty, lang: lang,
        net: hNetCents, gross: hGrossCents, v: CFG.version
      }));
      return;
    }

    // ---- FIXED_MC (round products): manufacturing cost x CF x CGF x QF
    //      v14.6: + optional frame colour surcharge, + optional fabric/textile
    //      add-on (circle area), + flat print-data fee — per Wolfgang/Katja
    //      ("Herstellkosten feste Abmessungen" doc §1). Fully opt-in: these are
    //      all zero/no-op unless the product actually links frame_colors and/or
    //      allowed_fabrics, so round products without them are UNCHANGED.
    //      v14.7: mc_cents can ALSO be entered directly in EUROS via the
    //      optional variant metafield custom.mc_euros (CFG.variantsEuros) — if
    //      present it wins; existing integer-cents products are untouched.
    //      v14.10: REMOVED the native-Price fallback (v14.8) per Wolfgang's
    //      confirmation — the HK must come from mc_cents or mc_euros ONLY. The
    //      variant's native Price field is used for other, unrelated purposes
    //      on the live theme and must never be read as the manufacturing cost.
    //      If neither metafield is filled in, the product correctly shows
    //      "price on request" instead of silently pulling the wrong number.
    var mcCents = 0;
    if (CFG.variantsEuros && vid && CFG.variantsEuros[vid]) {
      mcCents = Math.round(parseFloat(CFG.variantsEuros[vid]) * 100);
    } else if (CFG.variants && vid) {
      mcCents = parseInt(CFG.variants[vid], 10) || 0;
    }
    if (!mcCents || mcCents <= 0) { return fail(L.priceOnRequest); }

    var mcDiameter = fixedMcDiameterCm();
    var col = selectedColor();
    if ($colorName) $colorName.textContent = col.name;
    if ($ralWrap) $ralWrap.style.display = col.isRal ? 'block' : 'none';

    var fixFab = selectedFabric();
    updateTextileUI(fixFab);
    if (mcDiameter && ($fabricSelect || $fabricSelect2)) updateFabricAvailability(mcDiameter, 0, 0);

    var MCCOL = 0, MCSF = 0, MCT = 0;
    if (mcDiameter) {
      var circM = ralPerimeterMeters('PCIRCLE', mcDiameter, 0, 0);
      if (col.isRal) {
        MCSF = circM * CFG.settings.ralRate + CFG.settings.ralFlat;
      } else {
        MCCOL = col.useFormula ? (circM * CFG.settings.ralRate + CFG.settings.ralFlat) : col.surcharge;
      }
      if (fixFab) {
        var circAreaM2 = Math.PI * Math.pow(mcDiameter / 200, 2); // (diameter/2, cm->m)^2 x pi
        MCT = circAreaM2 * fixFab.mc + CFG.settings.fabricFlat;
      }
    }

    var qf = qtyFactor(qty);
    if (qf === null) {
      $price.style.display = 'none';
      $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
      $quote.style.display = 'block';
      setErr('');
      setSubmitEnabled(false);
      clearProps();
      return;
    }
    // v14.17: round products were never checking the design-catalogue
    // selection at all (dsg was hardcoded to null) — this meant a catalogue
    // motif could never reach the cart on round products, and the "hide
    // print-data when a catalogue motif is chosen" rule could never trigger
    // there either, unlike formula products where both already worked.
    var fixDsg = selectedDesign(fixFab);
    var fixPd = selectedPrintData(fixFab, fixDsg);
    var fixFixedAdds = (fixPd ? fixPd.price : 0) + (fixDsg ? fixDsg.price : 0);

    var spNet = (mcCents / 100 + MCT + MCCOL + MCSF) * CFG.factors.cf * CFG.factors.cgf * qf + fixFixedAdds;
    var netCents = Math.round(spNet * 100);
    var grossCents = Math.round(netCents * (1 + CFG.settings.vat));
    setErr('');
    $quote.style.display = 'none';
    $price.style.display = 'block';
    var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
    refreshAddonTiles();
    $net.textContent = fmt.format((netCents + adN) / 100);
    $gross.textContent = fmt.format((grossCents + adG) / 100);
    if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
    $line.textContent = L.lineTotal(qty, fmt.format(((grossCents + adG) * qty) / 100));
    showAddons(true);
    setSubmitEnabled(true);
    setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? grossCents : netCents);
    // v14.16: round products now go through the SAME shared writeProps() as
    // every other scenario — this is what actually fixes the missing cable
    // output property (selectedCable() is called here, exactly like the
    // formula-product path already did), and guarantees identical property
    // order across every product type from now on.
    writeProps({
      b: null, h: null, t: null, dim: false, dia: mcDiameter, exec: null,
      scenario: scen, vid: vid,
      fabric: fixFab ? fixFab.articleNo : null, fabricTitle: fixFab ? fixFab.title : null,
      fabric2: null, fabric2Title: null,
      printed: textileOnFn() ? printMode : null,
      color: col, ralCode: col.isRal && $ralCode ? $ralCode.value.trim() : null,
      pd: fixPd, dsg: fixDsg, cab: selectedCable(),
      qty: qty, netCents: netCents, grossCents: grossCents
    });
  }

  function compute() {
    if (hasScenarioSetup()) { return computeScenarioPrice(); }
    var b = parseInt($w.value, 10);
    var h = parseInt($h.value, 10);
    var t = $t ? parseInt($t.value, 10) : 0;
    var qty = getQty();

    // v14.9 — Stoffbanner (Kapitel 5, Wolfgang Stand 08/2026): fixed price per m²,
    // NO country/customer-group/quantity factors at all ("es gibt keine
    // Anpassungsfaktoren"), with a minimum billable area (0.5 m² unless the
    // formula overrides it). No frame, no colour, no fabric CHOICE — this
    // product IS one specific fabric; only the print-data fee is added on top.
    if (CFG.formula && CFG.formula.kind === 'AREA_FIX') {
      var errAF = validate(b, h, t);
      if (errAF) { return fail(errAF); }
      var synthFab = { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false };
      updateTextileUI(synthFab);
      var Araw = (b * h) / 10000;
      var Afix = Math.max(Araw, CFG.formula.minArea || 0.5);
      var pdAF = selectedPrintData(synthFab, null);
      var fixedAddsAF = pdAF ? pdAF.price : 0;
      var netCentsAF = Math.round((Afix * CFG.formula.fp + fixedAddsAF) * 100);
      var grossCentsAF = Math.round(netCentsAF * (1 + CFG.settings.vat));

      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adNAF = addonUnitNetCents(qty), adGAF = Math.round(adNAF * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((netCentsAF + adNAF) / 100);
      $gross.textContent = fmt.format((grossCentsAF + adGAF) / 100);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((grossCentsAF + adGAF) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);

      writeProps({
        b: b, h: h, t: null, dim: false, dia: null, exec: null,
        fabric: null, fabricTitle: null, fabric2: null, fabric2Title: null,
        printed: textileOnFn() ? printMode : null,
        color: { code: 'NONE', name: '', isRal: false }, ralCode: null,
        pd: pdAF, dsg: null, cab: null,
        qty: qty, netCents: netCentsAF, grossCents: grossCentsAF
      });
      return;
    }

    var col = selectedColor();

    if ($colorName) $colorName.textContent = col.name;
    if ($ralWrap) $ralWrap.style.display = col.isRal ? 'block' : 'none';

    updateFabricAvailability(b, h, t);
    var fab = selectedFabric();
    updateTextileUI(fab);

    var err = validate(b, h, t);
    if (err) { return fail(err); }

    var dim = CFG.formula.dimmingAvailable && $dim && $dim.checked;
    var MCR = computeMCR(b, h, t, dim);
    if (MCR === null) return fail('PX: formula config error for B=' + b);
    if (MCR < 0) MCR = 0;

    var fab2 = selectedFabric2();
    var MCT = computeMCT(fab, fab2, b, h, t);

    // v13.3: colour pricing (client feedback)
    // - RAL: perimeter formula (as before)
    // - colour with use_formula=true (e.g. black/white coating): SAME perimeter formula
    // - other colours: flat surcharge from the metaobject
    // - products with "ralIncluded":true (architects): every colour costs 0
    var colourFormula = ralPerimeterMeters(CFG.formula.ralPerimeter, b, h, t) * CFG.settings.ralRate + CFG.settings.ralFlat;
    var MCCOL = 0;
    if (!CFG.formula.ralIncluded && !col.isRal) {
      MCCOL = col.useFormula ? colourFormula : col.surcharge;
    }
    var MCSF = 0;
    if (col.isRal && !CFG.formula.ralIncluded) {
      MCSF = colourFormula;
    }

    var MC = MCR + MCT + MCCOL + MCSF;

    var qf = qtyFactor(qty);
    if (qf === null) {
      $price.style.display = 'none';
      $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
      $quote.style.display = 'block';
      setErr('');
      setSubmitEnabled(false);
      clearProps();
      return;
    }

    var dsg = selectedDesign(fab);
    var pd = selectedPrintData(fab, dsg); // null when catalogue motif chosen (point 6)
    var fixedAdds = (pd ? pd.price : 0) + (dsg ? dsg.price : 0);

    var spNet = MC * CFG.factors.cf * CFG.factors.cgf * qf + fixedAdds;
    var netCents = Math.round(spNet * 100);
    var grossCents = Math.round(netCents * (1 + CFG.settings.vat));

    setErr('');
    $quote.style.display = 'none';
    $price.style.display = 'block';
    var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
    refreshAddonTiles();
    $net.textContent = fmt.format((netCents + adN) / 100);
    $gross.textContent = fmt.format((grossCents + adG) / 100);
    if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
    $line.textContent = L.lineTotal(qty, fmt.format(((grossCents + adG) * qty) / 100));
    showAddons(true);
    setSubmitEnabled(true);

    writeProps({
      b: b, h: h, t: t, dim: !!dim, dia: null, exec: execLabel(),
      fabric: fab ? fab.articleNo : null, fabricTitle: fab ? fab.title : null,
      fabric2: (CFG.formula.dualFabric && fab2) ? fab2.articleNo : null,
      fabric2Title: (CFG.formula.dualFabric && fab2) ? fab2.title : null,
      printed: textileOnFn() ? printMode : null,
      color: col, ralCode: col.isRal && $ralCode ? $ralCode.value.trim() : null,
      pd: pd, dsg: dsg, cab: selectedCable(),
      qty: qty, netCents: netCents, grossCents: grossCents
    });
  }

  function fail(msg) {
    showAddons(false);
    setErr(msg);
    $price.style.display = 'none';
    $quote.style.display = 'none';
    setSubmitEnabled(false);
    clearProps();
  }

  function setSubmitEnabled(on) {
    if (!submitBtn) return;
    submitBtn.disabled = !on;
    submitBtn.setAttribute('aria-disabled', String(!on));
  }

  // ---------- line item properties ----------
  function setHidden(name, value) {
    if (!form) return;
    var sel = 'input[type="hidden"][name="' + CSS.escape(name) + '"]';
    var el = form.querySelector(sel);
    if (value === null || value === undefined || value === '') { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden'; el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  // v14.16: writeProps() is now the ONE shared cart-property writer for EVERY
  // scenario (formula, Stoffbanner, round products) — guarantees identical
  // property order and completeness everywhere. A field that does not apply
  // to a given scenario is simply passed as null; nothing is ever silently
  // "forgotten" in just one code path (this is exactly what caused the cable
  // output to go missing on round products before this version).
  function writeProps(s) {
    ALL_PROP_KEYS.forEach(function (k) { setHidden('properties[' + k + ']', null); });

    setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? s.grossCents : s.netCents);
    setHidden('properties[_cfg]', JSON.stringify({
      a: CFG.articleNo, scenario: s.scenario || null, vid: s.vid || null,
      b: s.b || null, h: s.h || null, t: s.t || null, dim: !!s.dim,
      dia: s.dia || null, exec: s.exec || null, prt: s.printed,
      fab: s.fabric, fab2: s.fabric2 || null, col: s.color.code,
      ral: s.color.isRal ? (s.ralCode || 'RAL') : null,
      pd: s.pd ? s.pd.code : null,
      dsg: s.dsg ? s.dsg.code : null,
      cab: s.cab ? s.cab.code : null,
      tier: CFG.factors.tier, cty: CFG.factors.country, qty: s.qty, lang: lang,
      net: s.netCents, gross: s.grossCents, v: CFG.version
    }));
    setHidden('properties[' + L.pW + ']', s.b || null);
    setHidden('properties[' + L.pH + ']', s.h || null);
    setHidden('properties[' + L.pT + ']', s.t || null);
    setHidden('properties[' + L.pDia + ']', s.dia || null);
    setHidden('properties[' + L.pDim + ']', s.dim ? L.yes : null);
    setHidden('properties[' + L.pExec + ']', s.exec || null);
    if (s.fabric2) {
      setHidden('properties[' + L.pFabF + ']', s.fabricTitle + ' (' + s.fabric + ')');
      setHidden('properties[' + L.pFabB + ']', s.fabric2Title + ' (' + s.fabric2 + ')');
    } else {
      setHidden('properties[' + L.pFab + ']', s.fabric ? (s.fabricTitle + ' (' + s.fabric + ')') : null);
    }
    setHidden('properties[' + L.pPrint + ']', (s.printed && s.fabric) ? (s.printed === 'YES' ? L.printWith : L.printWithout) : null);
    setHidden('properties[' + L.pPd + ']', s.pd ? s.pd.name : null);
    setHidden('properties[' + L.pDsg + ']', s.dsg ? s.dsg.name : null);
    setHidden('properties[' + L.pCab + ']', s.cab ? s.cab.name : null);
    // v14.16: whether colour applies is decided by whether the colour section
    // actually rendered ($colorName exists) — this is universally correct for
    // BOTH colorsDisabled formula products AND round products with no colour
    // linked, replacing the old formula-only "CFG.formula.colorsDisabled" check.
    if (!$colorName) {
      // no colour section on this product at all — nothing to write
    } else if (s.color.isRal) {
      setHidden('properties[' + L.pRal + ']', s.ralCode || L.yes);
    } else {
      setHidden('properties[' + L.pCol + ']', s.color.name);
    }
  }

  function clearProps() {
    ['_calculated_price', '_cfg'].forEach(function (k) { setHidden('properties[' + k + ']', null); });
    ALL_PROP_KEYS.forEach(function (k) { setHidden('properties[' + k + ']', null); });
  }

  // ---------- events ----------
  var deb;
  function schedule() { clearTimeout(deb); deb = setTimeout(compute, 150); }

  root.querySelectorAll('.px-stepper button[data-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.target);
      if (!input) return;
      var v = parseInt(input.value, 10) || parseInt(input.min, 10) || 0;
      v += parseInt(btn.dataset.step, 10);
      var min = parseInt(input.min, 10), max = parseInt(input.max, 10);
      if (!isNaN(min) && v < min) v = min;
      if (!isNaN(max) && v > max) v = max;
      input.value = v;
      schedule();
    });
  });

  function execLabel() {
    var active = root.querySelector('.px-exec-btn.px-active');
    if (!active) return L.withT;
    if (active.dataset.mode === 'NONE') return L.withoutT;
    if (active.dataset.mode === 'WITH') return L.withT;
    return active.textContent.trim();
  }
  $execBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      execMode = btn.dataset.mode;
      $execBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
      schedule();
    });
  });

  // v13: Mit Druck / Ohne Druck (client point 2)
  $printBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      printMode = btn.dataset.print;
      $printBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
      schedule();
    });
  });

  [$w, $h, $t].forEach(function (el) { el && el.addEventListener('input', schedule); });
  if ($dim) $dim.addEventListener('change', schedule);
  if ($ralCode) $ralCode.addEventListener('input', schedule);
  if ($fabricSelect) $fabricSelect.addEventListener('change', schedule);
  if ($fabricSelect2) $fabricSelect2.addEventListener('change', schedule);
  if ($pdSelect) $pdSelect.addEventListener('change', schedule);
  if ($cableSelect) $cableSelect.addEventListener('change', function () {
    updateCableSvgActive();
    schedule();
  });

  root.querySelectorAll('input[name="px-fcolor"]').forEach(function (r) {
    r.addEventListener('change', schedule);
  });

  // design catalogue
  if ($designToggle) $designToggle.addEventListener('change', schedule);
  if ($designCatalog) $designCatalog.addEventListener('change', function () {
    root.querySelectorAll('.px-design-panel').forEach(function (p) {
      p.classList.toggle('px-active-panel', p.dataset.catalog === $designCatalog.value);
    });
    schedule();
  });
  root.querySelectorAll('.px-design-panel input[type="radio"]').forEach(function (r) {
    r.addEventListener('change', schedule);
  });
  root.querySelectorAll('.px-dtile .px-dimg').forEach(function (img) {
    img.addEventListener('click', function () {
      var radio = img.closest('.px-dtile').querySelector('input[type="radio"]');
      if (radio && !radio.checked) { radio.checked = true; schedule(); }
      if (img.dataset.full) openLightbox(img.dataset.full);
    });
  });

  // ---------- v13 upload: Drag & Drop zone (client design; fixes v12 click bug) ----------
  function uploadInputs() {
    return Array.prototype.slice.call(root.querySelectorAll('.px-upinput'));
  }
  function anyFiles() {
    return uploadInputs().some(function (inp) { return inp.files && inp.files.length; });
  }
  function clearAllFiles() {
    uploadInputs().forEach(function (inp) { inp.value = ''; });
    refreshUploadList();
  }
  // v14.1: each fabric side has its OWN upload zone (front + back on dualFabric
  // products). Every wrap is wired independently: its dropzone fills its own
  // slots only, and shows its own file list.
  function wrapInputs(w) {
    return Array.prototype.slice.call(w.querySelectorAll('.px-upinput'));
  }
  function refreshWrapList(w) {
    var lst = w.querySelector('.px-uplist');
    if (!lst) return;
    lst.innerHTML = '';
    wrapInputs(w).forEach(function (inp) {
      if (!inp.files || !inp.files.length) return;
      var row = document.createElement('div');
      row.className = 'px-uprow';
      var name = document.createElement('span');
      name.textContent = inp.files[0].name;
      var del = document.createElement('button');
      del.type = 'button';
      del.textContent = '\u2715';
      del.setAttribute('aria-label', 'remove');
      del.addEventListener('click', function () {
        inp.value = '';
        refreshWrapList(w);
        schedule();
      });
      row.appendChild(name); row.appendChild(del);
      lst.appendChild(row);
    });
  }
  function refreshUploadList() {
    $pfUpWraps.forEach(refreshWrapList);
  }
  $pfUpWraps.forEach(function (w) {
    var dz = w.querySelector('.px-dropzone');
    function nextEmptyInWrap() {
      var inputs = wrapInputs(w);
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].files || !inputs[i].files.length) return inputs[i];
      }
      return null;
    }
    function assignToWrap(fileList) {
      var assigned = false;
      Array.prototype.forEach.call(fileList, function (file) {
        var inp = nextEmptyInWrap();
        if (!inp) return;
        var dt = new DataTransfer();
        dt.items.add(file);
        inp.files = dt.files;
        assigned = true;
      });
      if (assigned) {
        if ($designToggle && $designToggle.checked) $designToggle.checked = false; // exclusivity
        refreshWrapList(w);
        schedule();
      }
    }
    if (dz) {
      dz.addEventListener('click', function () {
        var inp = nextEmptyInWrap();
        if (inp) inp.click();
      });
      dz.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dz.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        dz.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation();
          dz.classList.add('px-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dz.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation();
          dz.classList.remove('px-dragover');
        });
      });
      dz.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          assignToWrap(e.dataTransfer.files);
        }
      });
    }
    wrapInputs(w).forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (inp.files && inp.files.length && $designToggle && $designToggle.checked) {
          $designToggle.checked = false; // file chosen -> catalogue off (one option at a time)
        }
        refreshWrapList(w);
        schedule();
      });
    });
  });
  refreshUploadList();

  // ---------- v14.0: Handelsware textile UI wiring ----------
  function hwUpdateSlots() {
    if (!$hwWrap) return;
    $hwWrap.querySelectorAll('.px-hw-slot').forEach(function (slot) {
      var i = parseInt(slot.dataset.slot, 10);
      slot.style.display = (i <= hwCount) ? 'block' : 'none';
      var info = slot.querySelector('.px-hw-info');
      var sel = slot.querySelector('.px-hw-fabric');
      if (info && sel) {
        var opt = sel.options[sel.selectedIndex];
        var txt = opt ? (tooltipFor(opt.dataset.title || opt.text) || opt.dataset.info) : null;
        if (i <= hwCount && txt) { info.textContent = txt; info.style.display = 'block'; }
        else { info.style.display = 'none'; }
      }
      if (i > hwCount) {
        var inp = slot.querySelector('.px-hw-upinput');
        if (inp && inp.files && inp.files.length) { inp.value = ''; }
        var lst = slot.querySelector('.px-hw-uplist');
        if (lst) lst.innerHTML = '';
      }
    });
    if ($hwPd) $hwPd.style.display = (hwCount > 0) ? 'block' : 'none';
  }
  if ($hwWrap) {
    $hwModeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        hwCount = parseInt(btn.dataset.count, 10) || 0;
        $hwModeBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
        hwUpdateSlots();
        schedule();
      });
    });
    $hwWrap.querySelectorAll('.px-hw-fabric').forEach(function (sel) {
      sel.addEventListener('change', function () { hwUpdateSlots(); schedule(); });
    });
    if ($hwPdSelect) $hwPdSelect.addEventListener('change', schedule);
    $hwWrap.querySelectorAll('.px-hw-drop').forEach(function (dz) {
      var slot = dz.dataset.slot;
      var inp = $hwWrap.querySelector('.px-hw-upinput[data-slot="' + slot + '"]');
      var lst = $hwWrap.querySelector('.px-hw-uplist[data-slot="' + slot + '"]');
      function renderList() {
        if (!lst) return;
        lst.innerHTML = '';
        if (inp && inp.files && inp.files.length) {
          var row = document.createElement('div');
          row.className = 'px-uprow';
          var name = document.createElement('span');
          name.textContent = inp.files[0].name;
          var del = document.createElement('button');
          del.type = 'button'; del.textContent = '\u2715';
          del.addEventListener('click', function () { inp.value = ''; renderList(); schedule(); });
          row.appendChild(name); row.appendChild(del);
          lst.appendChild(row);
        }
      }
      if (dz && inp) {
        dz.addEventListener('click', function () { inp.click(); });
        dz.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.click(); }
        });
        ['dragenter','dragover'].forEach(function (ev) {
          dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dz.classList.add('px-dragover'); });
        });
        ['dragleave','drop'].forEach(function (ev) {
          dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dz.classList.remove('px-dragover'); });
        });
        dz.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            var dt = new DataTransfer();
            dt.items.add(e.dataTransfer.files[0]);
            inp.files = dt.files;
            renderList(); schedule();
          }
        });
        inp.addEventListener('change', function () { renderList(); schedule(); });
      }
    });
    hwUpdateSlots();
  }

  // ---------- v13.2: inline interactive SVG cable diagram ----------
  // Drawn by us (frame + numbered circles + plug), so it scales perfectly on
  // every device — no image-overlay alignment problems. Positions come from
  // CFG.cableHotspots percentages; the SVG canvas is 1314 x 1197 units.
  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(tag, attrs, parent) {
    var el = document.createElementNS(SVGNS, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(el);
    return el;
  }
  function updateCableSvgActive() {
    if (!$cableSvgWrap || !$cableSelect) return;
    var cur = $cableSelect.value;
    $cableSvgWrap.querySelectorAll('.px-cs-hit').forEach(function (g) {
      g.classList.toggle('px-cs-active', g.getAttribute('data-val') === cur);
    });
    // v14.25: round LED products (circle_square) — the plug+cable icon follows
    // whichever position is currently selected, instead of sitting fixed on one.
    $cableSvgWrap.querySelectorAll('.px-cs-plug').forEach(function (g) {
      g.style.display = (g.getAttribute('data-val') === cur) ? '' : 'none';
    });
  }
  function buildCableSvg() {
    if (!$cableSvgWrap || !$cableSelect) return false;
    var spots = CFG.cableHotspots;
    if (!spots) return false;
    // v13.6.1: if the liquid rendered an empty dropdown (positions field missing),
    // build the options from the hotspot numbers so the section still works
    if ($cableSelect.options.length === 0) {
      Object.keys(spots).filter(function (k) { return k !== 'shape'; })
        .sort(function (a, b) { return a - b; })
        .forEach(function (k, i) {
          var o = document.createElement('option');
          o.value = k; o.textContent = k; if (i === 0) o.selected = true;
          $cableSelect.appendChild(o);
        });
    }
    var W = 1314, H = 1197;
    var svg = svgEl('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'px-cablesvg', role: 'group' });
    svg.setAttribute('aria-label', L.cableLabel);
    // v13.6: frame shape from hotspots JSON "shape" key — 'rectangle' (default) / 'square' / 'circle' / 'circle_square'
    var shape = spots.shape === 'circle' ? 'circle'
      : spots.shape === 'square' ? 'square'
      : spots.shape === 'circle_square' ? 'circle_square'
      : 'rect';
    if (shape === 'circle' || shape === 'circle_square') {
      svgEl('circle', { cx: 571, cy: 569, r: 490, fill: 'none',
                        stroke: '#58585a', 'stroke-width': 16 }, svg);
    } else if (shape === 'square') {
      svgEl('rect', { x: 167, y: 79, width: 980, height: 980, rx: 10, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 16 }, svg);
    } else {
      svgEl('rect', { x: 84, y: 79, width: 974, height: 980, rx: 10, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 16 }, svg);
    }
    // v14.23: round LED products (Wolfgang) — an inner square drawn inside the
    // circle, representing the mounting panel; only 2 hotspots normally used
    // with this shape, positioned on/near this inner square.
    if (shape === 'circle_square') {
      svgEl('rect', { x: 281, y: 279, width: 580, height: 580, rx: 6, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 10 }, svg);
    }
    // plug icon bottom right: cable starts at position 5 (ring point differs per shape)
    // v14.24: circle_square does NOT use this large external plug at all — see below,
    // it gets a small plug drawn directly next to hotspot 1, inside the square.
    var cableD = shape === 'circle'
      ? 'M 866 960 C 1000 1130 1180 1120 1186 1010 L 1186 992'
      : shape === 'square'
        ? 'M 1030 1060 C 1100 1160 1180 1130 1186 1010 L 1186 992'
        : 'M 950 1060 C 1060 1165 1180 1140 1186 1010 L 1186 992';
    if (shape !== 'circle_square') {
      var plug = svgEl('g', { fill: 'none', stroke: '#58585a' }, svg);
      svgEl('path', { d: cableD, 'stroke-width': 30, 'stroke-linecap': 'round' }, plug);
      svgEl('path', { d: cableD, 'stroke-width': 12, stroke: '#ffffff', 'stroke-linecap': 'round' }, plug);
      svgEl('path', { d: 'M 1152 992 h 68 v -58 q 0 -16 -16 -20 h -36 q -16 4 -16 20 z',
                      fill: '#fdf8f6', 'stroke-width': 12, 'stroke-linejoin': 'round' }, plug);
      svgEl('rect', { x: 1163, y: 862, width: 11, height: 52, fill: '#58585a', stroke: 'none' }, plug);
      svgEl('rect', { x: 1198, y: 862, width: 11, height: 52, fill: '#58585a', stroke: 'none' }, plug);
    } else {
      // v14.25: round LED products — one plug+cable icon PER hotspot, computed
      // from that hotspot's own real position (not hardcoded), so it always
      // stays correctly attached even if the coordinates are nudged later.
      // Only the plug matching the CURRENTLY SELECTED position is shown —
      // updateCableSvgActive() toggles this every time the customer clicks a
      // different position. Bigger than the first attempt, per feedback.
      Object.keys(spots).filter(function (k) { return k !== 'shape'; }).forEach(function (val) {
        var pos = spots[val];
        if (!pos || pos.length < 2) return;
        var px = pos[0] * W / 100, py = pos[1] * H / 100;
        var bx = px + 65, by = py - 120; // plug body offset: how far right/up from the dot — see note below on adjusting this
        var miniPlug = svgEl('g', { 'class': 'px-cs-plug', 'data-val': val,
                                     fill: 'none', stroke: '#58585a',
                                     style: 'display:none' }, svg);
        var curlD = 'M ' + (bx + 5) + ' ' + (by + 38) + ' C ' + (bx - 25) + ' ' + (by + 55) + ' ' + (px - 8) + ' ' + (py - 20) + ' ' + px + ' ' + py;
        svgEl('path', { d: curlD, 'stroke-width': 14, 'stroke-linecap': 'round' }, miniPlug);
        svgEl('path', { d: curlD, 'stroke-width': 6, stroke: '#ffffff', 'stroke-linecap': 'round' }, miniPlug);
        svgEl('rect', { x: bx, y: by, width: 66, height: 46, rx: 7, fill: '#fdf8f6',
                        'stroke-width': 7, 'stroke-linejoin': 'round' }, miniPlug);
        svgEl('rect', { x: bx + 16, y: by - 22, width: 10, height: 26, fill: '#58585a', stroke: 'none' }, miniPlug);
        svgEl('rect', { x: bx + 40, y: by - 22, width: 10, height: 26, fill: '#58585a', stroke: 'none' }, miniPlug);
      });
    }
    // numbered, clickable circles
    for (var i = 0; i < $cableSelect.options.length; i++) {
      (function (val) {
        var pos = spots[val];
        if (!pos || pos.length < 2) return;
        var cx = pos[0] * W / 100, cy = pos[1] * H / 100;
        var g = svgEl('g', { 'class': 'px-cs-hit', 'data-val': val, tabindex: '0', role: 'button' }, svg);
        g.setAttribute('aria-label', L.pos(val));
        svgEl('circle', { cx: cx, cy: cy, r: 62, 'class': 'px-cs-ring' }, g);
        svgEl('circle', { cx: cx, cy: cy, r: 46, fill: '#58585a', 'class': 'px-cs-dot' }, g);
        var t = svgEl('text', { x: cx, y: cy, 'class': 'px-cs-num',
                                'text-anchor': 'middle', 'dominant-baseline': 'central' }, g);
        t.textContent = val;
        function choose() {
          $cableSelect.value = val;
          $cableSelect.dispatchEvent(new Event('change', { bubbles: true }));
          updateCableSvgActive();
        }
        g.addEventListener('click', choose);
        g.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
      })($cableSelect.options[i].value);
    }
    $cableSvgWrap.appendChild(svg);
    updateCableSvgActive();
    if ($cableDiagram) $cableDiagram.style.display = 'none'; // metaobject image not needed
    return true;
  }
  var cableSvgActive = buildCableSvg();

  // ---------- lightbox (centered, scroll-locked) ----------
  function openLightbox(src) {
    if ($lightbox && $lightboxImg) {
      $lightboxImg.src = src;
      if ($lightboxHotspots) $lightboxHotspots.innerHTML = '';
      $lightbox.classList.add('px-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeLightbox() {
    if ($lightbox) $lightbox.classList.remove('px-open');
    if ($lightboxImg) $lightboxImg.src = '';
    if (!$infoModal || !$infoModal.classList.contains('px-open')) document.body.style.overflow = '';
  }
  if ($cableDiagram && !cableSvgActive) $cableDiagram.addEventListener('click', function () {
    openLightbox($cableDiagram.dataset.full);
  });
  if ($lightboxClose) $lightboxClose.addEventListener('click', closeLightbox);
  if ($lightbox) $lightbox.addEventListener('click', function (e) {
    if (e.target === $lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLightbox(); closeInfoModal(); }
  });

  // ---------- v14.4: fabric-info popup (centered, scroll-locked, same pattern as lightbox) ----------
  // One icon per textile dropdown (works for 1 up to 6 slots alike); clicking it lists
  // EVERY fabric offered in THAT dropdown (name + tooltip text), not just the selected one.
  function escapeHtmlPx(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function openInfoModal(selectId) {
    var sel = document.getElementById(selectId);
    if (!sel || !$infoModal || !$infoModalBody) return;
    // modal now lives outside the configurator's own container (to escape a fixed
    // ancestor), so its title is set here on every open rather than by applyLang()
    if ($infoModalTitle) $infoModalTitle.textContent = L.infoModalTitle;
    var html = '';
    Array.prototype.forEach.call(sel.options, function (opt) {
      var title = opt.dataset.title || opt.text;
      var info = tooltipFor(title) || opt.dataset.info || '';
      html += '<div class="px-info-fab"><b>' + escapeHtmlPx(title) + '</b>' + (info ? escapeHtmlPx(info) : '') + '</div>';
    });
    $infoModalBody.innerHTML = html;
    $infoModal.classList.add('px-open');
    document.body.style.overflow = 'hidden';
  }
  function closeInfoModal() {
    if ($infoModal) $infoModal.classList.remove('px-open');
    if (!$lightbox || !$lightbox.classList.contains('px-open')) document.body.style.overflow = '';
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.px-info-btn');
    if (btn) { e.preventDefault(); openInfoModal(btn.dataset.for); }
  });
  if ($infoModalClose) $infoModalClose.addEventListener('click', closeInfoModal);
  if ($infoModal) $infoModal.addEventListener('click', function (e) {
    if (e.target === $infoModal) closeInfoModal();
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') schedule();
    else if (hasScenarioSetup()) schedule();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity') schedule();
  });

  // ---------- add-to-cart submit ----------
  // No files: normal theme flow. Files: FormData takeover (theme AJAX drops file
  // inputs), then the drawer ALWAYS opens: renderContents, else reload + auto-open.
  if (form) form.addEventListener('submit', function (e) {
    clearTimeout(deb);
    compute();
    var priced = form.querySelector('input[name="properties[_calculated_price]"]');
    if (!priced || !priced.value) { e.preventDefault(); e.stopPropagation(); return; }

    var addonSel = addonSelection();
    if (!anyFiles() && !addonSel) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var fd = new FormData(form);
    root.querySelectorAll('.px-upinput').forEach(function (inp) {
      if (inp.files && inp.files.length && !fd.has(inp.name)) fd.append(inp.name, inp.files[0]);
    });
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    if (submitBtn) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('PX add error', data);
          alert(data.description || data.message || L.addError);
          return;
        }
        if (addonSel) {
          // second line: the add-on, factor-priced via _calculated_price
          var q2 = getQty();
          var adNet = addonUnitNetCents(q2);
          var adGross = Math.round(adNet * (1 + CFG.settings.vat));
          var props = {};
          props[L.pAddonFor] = CFG.articleNo;
          props['_calculated_price'] = String(CFG.settings.taxesIncluded ? adGross : adNet);
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addonSel.variantId, quantity: q2, properties: props })
          }).catch(function (err) { console.error('PX addon add failed', err); })
            .finally(function () {
              try { sessionStorage.setItem('px-open-drawer', '1'); } catch (e2) {}
              window.location.reload();
            });
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        try {
          if (drawer && data.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
            return;
          }
        } catch (err) {
          console.warn('PX drawer render failed, falling back to reload', err);
        }
        try { sessionStorage.setItem('px-open-drawer', '1'); } catch (e2) {}
        window.location.reload();
      })
      .catch(function (err) {
        console.error('PX add failed', err);
        try { sessionStorage.setItem('px-open-drawer', '1'); } catch (e2) {}
        window.location.reload();
      })
      .finally(function () {
        if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.disabled = false; }
      });
  }, true);

  // if the last add-to-cart fell back to a reload, open the drawer now
  try {
    if (sessionStorage.getItem('px-open-drawer') === '1') {
      sessionStorage.removeItem('px-open-drawer');
      var pxDrawer = document.querySelector('cart-drawer');
      if (pxDrawer && typeof pxDrawer.open === 'function') {
        setTimeout(function () { pxDrawer.open(); }, 250);
      }
    }
  } catch (e) {}

  setSubmitEnabled(false);
  applyLang();
})();